/**
 * Sports Betting Service
 * Handles all sports betting API calls
 */

import { API_URL } from '../../utils/constants';

const API_ROOT = `${API_URL}/sportsbetting`;

export const placeBet = async (betData) => {
  try {
    const response = await fetch(`${API_ROOT}/place`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(betData),
    });

    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      throw new Error(data.message || data.error || `HTTP ${response.status}`);
    }
    return data;
  } catch (error) {
    console.error('Error placing bet:', error);
    throw error;
  }
};

export const getUserExposures = async (userId) => {
  try {
    const response = await fetch(`${API_ROOT}/exposures/${userId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      throw new Error(data.message || data.error || `HTTP ${response.status}`);
    }
    return data;
  } catch (error) {
    console.error('Error fetching exposures:', error);
    throw error;
  }
};

export const getWalletBalance = async (userId) => {
  try {
    const response = await fetch(`${API_ROOT}/wallet/${userId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      throw new Error(data.message || data.error || `HTTP ${response.status}`);
    }
    return data;
  } catch (error) {
    console.error('Error fetching wallet balance:', error);
    throw error;
  }
};

export const checkSportsEnabled = async () => {
  try {
    const response = await fetch(`${API_URL}/sportsCheck`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error checking sports status:', error);
    throw error;
  }
};

/**
 * Fetch betting history for a user
 * @param {string|number} userId - User ID
 * @returns {Promise<Object>} Betting history data
 */
export const getBettingHistory = async (userId) => {
  try {
    if (!userId) {
      return { success: false, bets: [] };
    }

    const response = await fetch(`${API_ROOT}/history/${userId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      throw new Error(data.message || data.error || `HTTP ${response.status}`);
    }
    return data;
  } catch (error) {
    console.error('Error fetching betting history:', error);
    throw error;
  }
};
